// Copyright (c) 2025. CYBERKOALA LLC.
//
// SPDX-License-Identifier: Proprietary License.
//
// Redistribution and use in source and binary forms, with or without
// modification, are restricted.

import React from 'react';

export const HeadData: React.FC = () => (
  <>
    <link
      rel="icon"
      href="https://web.calls.cyberkoala.ru/favicon-32x32.ico"
      sizes="32x32"
      type="image/x-icon"
    />
    <link
      rel="icon"
      href="https://web.calls.cyberkoala.ru/logo.svg"
      type="image/svg+xml"
      as="image"
    />
    <link
      rel="preload"
      href="https://web.calls.cyberkoala.ru/logo.svg"
      as="image"
      fetchPriority="high"
    />
    <link rel="icon" href="https://web.calls.cyberkoala.ru/favicon-32x32.ico" />
    <link rel="icon" href="https://web.calls.cyberkoala.ru/favicon-120x120.png" />
    <link rel="icon" href="https://web.calls.cyberkoala.ru/favicon-16x16.png" sizes="16x16" />
    <link rel="icon" href="https://web.calls.cyberkoala/favicon-32x32.png" sizes="32x32" />
    <link rel="icon" href="https://web.calls.cyberkoala/favicon-96x96.png" sizes="96x96" />
    <link rel="icon" href="https://web.calls.cyberkoala/favicon-120x120.png" sizes="120x120" />
    <link rel="icon" href="https://web.calls.cyberkoala/favicon-128x128.png" sizes="128x128" />
    <link rel="icon" href="https://web.calls.cyberkoala/favicon-192x192.png" sizes="192x192" />
    <meta property="og:type" content="website" />
    <meta property="og:site_name" content="CyberKoala Calls" />
  </>
);
